module.exports = __webpack_public_path__ + "static/media/tree.5ee135db.svg";